import React from 'react';
import Loader from './Loader';
import { Table as AcTable } from '@acoer/ac-js-lib-charts';

interface TableProps {
    loading: boolean;
    data: any;
    title?: any;
    columns: any;
    handleTableChange: any;
    count: number;
    pageNumber: number;
    pageLimit: number;
    sortOrder: any;
    onRowClick?: any;
    filter?: boolean;
    search?: boolean;
    rowsList?: number[];
}
const Table: React.FC<TableProps> = ({
    loading,
    handleTableChange,
    count,
    columns,
    pageLimit,
    pageNumber,
    sortOrder,
    data,
    title,
    onRowClick,
    filter,
    search,
    rowsList,
}) => {
    const loadingComponent = (
        <div
            style={{
                position: 'absolute',
                zIndex: 110,
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: `#fff80`,
            }}
        >
            <Loader size={60} color={'#60CEBD'} />
        </div>
    );
    return (
        <div
            id="FileImportDiv"
            style={{ position: 'relative', cursor: 'auto' }}
        >
            {loading && loadingComponent}
            <AcTable
                data={data}
                columns={columns}
                onDownloadCsv={() => console.log('hi')}
                chartTitle={title || ''}
                onTableChange={handleTableChange}
                count={count || 0}
                page={pageNumber}
                serverSide
                pagination
                rowsPerPage={pageLimit}
                onRowClick={onRowClick ? onRowClick : null}
                sortOrder={sortOrder}
                filter={filter || false}
                search={search || false}
                rowsPerPageOptions={rowsList ? rowsList : [10, 20, 50]}
            />
        </div>
    );
};

export default Table;
